/**
 * Dhatu Organics — Scroll-triggered fade-in animations
 * Uses IntersectionObserver. Applies .is-visible to
 * .dhatu-fade-in and .dhatu-stagger elements as they enter the viewport.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    // Fallback: show everything immediately
    document.querySelectorAll('.dhatu-fade-in, .dhatu-stagger').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -32px 0px' }
  );

  function init() {
    document.querySelectorAll('.dhatu-fade-in, .dhatu-stagger').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
